export default __webpack_public_path__ + "static/media/custom.0c1e9ae2.svg";